<title mat-dialog-title>{{ this.address }}</title>
<mat-dialog-content class="appliance-map-maximizer-dialog-content">
  <fs-map (mapInit)="onMapInit($event)"></fs-map>
</mat-dialog-content>
<mat-dialog-actions class="appliance-map-maximizer-dialog-actions">
  <button mat-button color="warn" (click)="close()">Close</button>
</mat-dialog-actions>
